"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import { useContentTab } from "@/components/brain/ContentTabContext";
import MemesArtSubmissionModal from "@/components/waves/memes/MemesArtSubmissionModal";
import MyStreamWaveTabsMemeSubmit from "./MyStreamWaveTabsMemeSubmit";
import { useWave } from "../../../../hooks/useWave";
import { useDecisionPoints } from "../../../../hooks/waves/useDecisionPoints";
import { Time } from "../../../../helpers/time";
import { calculateTimeLeft, TimeLeft } from "../../../../helpers/waves/time.utils";
import { CompactTimeCountdown } from "../../../waves/leaderboard/time/CompactTimeCountdown";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleLeftIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import WavePicture from "../../../waves/WavePicture";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { createBreakpoint } from "react-use";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface MyStreamWaveTabsMemeProps {
  readonly wave: ApiWave;
}
const MyStreamWaveTabsMeme: React.FC<MyStreamWaveTabsMemeProps> = t0 => {
  const $ = _c(64);
  const {
    wave
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const {
    toggleRightSidebar,
    isRightSidebarOpen
  } = useSidebarState();
  const [isMemesModalOpen, setIsMemesModalOpen] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "S";
  const {
    isMemesWave,
    isRankWave,
    pauses: t1
  } = useWave(wave);
  const {
    filterDecisionsDuringPauses
  } = t1;
  const {
    allDecisions
  } = useDecisionPoints(wave);
  let t2;
  if ($[0] !== allDecisions || $[1] !== filterDecisionsDuringPauses) {
    const decisionsAsApiFormat = allDecisions.map(_temp);
    const filtered = filterDecisionsDuringPauses(decisionsAsApiFormat);
    t2 = allDecisions.filter(decision_0 => filtered.some(f => f.decision_time === decision_0.timestamp));
    $[0] = allDecisions;
    $[1] = filterDecisionsDuringPauses;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const filteredDecisions = t2;
  let t3;
  if ($[3] !== filteredDecisions) {
    t3 = filteredDecisions.find(_temp2)?.timestamp ?? null;
    $[3] = filteredDecisions;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const nextDecisionTime = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [timeLeft, setTimeLeft] = useState(t4);
  let t5;
  let t6;
  if ($[6] !== nextDecisionTime) {
    t5 = () => {
      if (nextDecisionTime) {
        setTimeLeft(calculateTimeLeft(nextDecisionTime));
        const intervalId = setInterval(() => {
          const newTimeLeft = calculateTimeLeft(nextDecisionTime);
          setTimeLeft(newTimeLeft);
          if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
            clearInterval(intervalId);
          }
        }, 1000);
        return () => clearInterval(intervalId);
      }
    };
    t6 = [nextDecisionTime];
    $[6] = nextDecisionTime;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMemesModalOpen(true);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleMemesSubmit = t7;
  let t8;
  if ($[10] !== pathname || $[11] !== router || $[12] !== searchParams) {
    t8 = () => {
      const params = new URLSearchParams(searchParams?.toString() || "");
      params.delete("wave");
      const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname || "/waves";
      router.push(newUrl, {
        scroll: false
      });
    };
    $[10] = pathname;
    $[11] = router;
    $[12] = searchParams;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleMobileBack = t8;
  let t9;
  if ($[14] !== handleMobileBack || $[15] !== isMobile) {
    t9 = isMobile && <button onClick={handleMobileBack} className="tw-flex tw-items-center tw-h-full tw-px-2.5 -tw-ml-2.5 tw-mr-1.5 tw-bg-transparent tw-border-0 tw-text-iron-300 hover:tw-text-iron-50 tw-transition-colors tw-p-0" aria-label="Go back"><ArrowLeftIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0" /></button>;
    $[14] = handleMobileBack;
    $[15] = isMobile;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = wave.name;
  const t11 = wave.picture;
  let t12;
  if ($[17] !== wave.contributors_overview) {
    t12 = wave.contributors_overview.map(_temp3);
    $[17] = wave.contributors_overview;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== wave.name || $[21] !== wave.picture) {
    t13 = <div className="tw-size-6 lg:tw-size-9 tw-flex-shrink-0 tw-ring-1 tw-ring-offset-1 tw-ring-offset-iron-950 tw-ring-white/30 tw-rounded-full"><WavePicture name={t10} picture={t11} contributors={t12} /></div>;
    $[19] = t12;
    $[20] = wave.name;
    $[21] = wave.picture;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== wave.name) {
    t14 = <h1 className="tw-ml-3 tw-text-sm lg:tw-text-xl tw-font-semibold tw-text-white/95 tw-tracking-tight tw-mb-0 tw-truncate">{wave.name}</h1>;
    $[23] = wave.name;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14 || $[27] !== t9) {
    t15 = <div className="tw-flex tw-items-center">{t9}{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t9;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== wave) {
    t16 = <div className="tw-hidden lg:tw-block"><MyStreamWaveTabsMemeSubmit handleMemesSubmit={handleMemesSubmit} wave={wave} /></div>;
    $[29] = wave;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 tw-transition tw-duration-300 ${isRightSidebarOpen ? "tw-rotate-180 desktop-hover:group-hover:tw-translate-x-0.5" : "tw-rotate-0 desktop-hover:group-hover:-tw-translate-x-0.5"}`;
  let t18;
  if ($[31] !== t17) {
    t18 = <ChevronDoubleLeftIcon strokeWidth={2} className={t17} />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t18 || $[34] !== toggleRightSidebar) {
    t19 = <button type="button" onClick={toggleRightSidebar} className="tw-group tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-right-0 tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-700 tw-backdrop-blur-sm tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-iron-500/80 desktop-hover:hover:tw-bg-iron-700/85 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)]" aria-label="Toggle right sidebar">{t18}</button>;
    $[33] = t18;
    $[34] = toggleRightSidebar;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t16 || $[37] !== t19) {
    t20 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-relative tw-pr-10">{t16}{t19}</div>;
    $[36] = t16;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t15 || $[40] !== t20) {
    t21 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-px-2 sm:tw-px-4 tw-py-3 tw-overflow-x-hidden">{t15}{t20}</div>;
    $[39] = t15;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== activeContentTab || $[43] !== setActiveContentTab || $[44] !== wave) {
    t22 = <MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} />;
    $[42] = activeContentTab;
    $[43] = setActiveContentTab;
    $[44] = wave;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== isMemesWave || $[47] !== isRankWave || $[48] !== nextDecisionTime || $[49] !== timeLeft) {
    t23 = (isMemesWave || isRankWave) && nextDecisionTime && <div className="tw-flex-shrink-0 tw-px-2 sm:tw-px-4"><CompactTimeCountdown timeLeft={timeLeft} /></div>;
    $[46] = isMemesWave;
    $[47] = isRankWave;
    $[48] = nextDecisionTime;
    $[49] = timeLeft;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t22 || $[52] !== t23) {
    t24 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-x-0 tw-border-y tw-border-solid tw-border-iron-800">{t22}{t23}</div>;
    $[51] = t22;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t21 || $[55] !== t24) {
    t25 = <div className="tw-w-full tw-flex tw-flex-col tw-bg-iron-950">{t21}{t24}</div>;
    $[54] = t21;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setIsMemesModalOpen(false);
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== isMemesModalOpen || $[59] !== wave) {
    t27 = <MemesArtSubmissionModal isOpen={isMemesModalOpen} wave={wave} onClose={t26} />;
    $[58] = isMemesModalOpen;
    $[59] = wave;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t25 || $[62] !== t27) {
    t28 = <>{" "}{t25}{t27}</>;
    $[61] = t25;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  return t28;
};
export default MyStreamWaveTabsMeme;
function _temp(decision) {
  return {
    decision_time: decision.timestamp
  };
}
function _temp2(decision_1) {
  return decision_1.timestamp > Time.currentMillis();
}
function _temp3(c) {
  return {
    pfp: c.contributor_pfp
  };
}